module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox, $) {
	
	fox.registerWidget('BillingSupport_BillingContact', {

		configure: function () {

			this.data = {};

			this.registerOptions('', {
				autoRender: true,
				container: '.contact-form-wrapper',
				template: 'billingSupport_contact_form',

				widgets: {
					api: {
						widget: 'Api',
						method: 'User.supportContact'
					},

					successPopup: {
						widget: 'Popup_Common',
						'widgets.content.template': 'popup_billingInfo_contact_success'
					},
				},

				handleWom: {
					handleApiResponse: {
						widget: '#api',
						event: ['success', 'error', 'failure'],
						callback: '_handleApiResponse'
					},

					// redirect: {
					// 	widget: '#successPopup',
					// 	event: 'hide',
					// 	callback: '_redirect'
					// }
				},

				handleDom: {
					formSubmit: {
						target: 'form#billing-contact-form',
						event: 'submit',
						callback: '_submit'
					},
					// select: {
					// 	target: 'select[name="problem"]',
					// 	event: 'change',
					// 	callback: '_change'
					// },
					input: {
						target: 'input[name], textarea[name]',
						event: 'input',
						callback: '_handleInput'
					}
				}
			});

			this.callParent('configure', arguments);
		},

		_submit: function (el, alias, w, e) {
			fox.dom.event.stop(e);

			this.data.firstname = this.dom1('[name="firstname"]').value;
			this.data.lastname = this.dom1('[name="lastname"]').value;
			this.data.description = this.dom1('[name="description"]').value;
			this.data.problem = 'General questions';
			
			if (this.isValid()) {
				this.submit();
			}
		},

		isValid: function (argument) {
			var result = true;

			fox.each(['firstname', 'lastname', 'description'], function (alias) {
				this.toggleField(alias, false);

				if (fox.isEmpty(this.data[alias])) {
					this.toggleField(alias, true);
					result = false;
				}
			}, this);

			return result;
		},

		toggleField: function (alias, state) {
			var action = (state === true ? 'addClass' : 'removeClass');
			var field = this.dom1('[name="' + alias + '"]');
			var parent = field.parentNode;
			var sibling = parent.nextSibling;
			if (alias == 'problem') {
				parent = field.parentNode.parentNode;
			};

			fox.dom[action]('error', parent);
			sibling.innerHTML = (field.validationMessage || '&nbsp;');
		},

		submit: function (argument) {
			this.wom1('#api').send(this.data)
		},

		_handleInput: function (el) {
			if (el.value.length > 0) {
				this.toggleField(el.name, false);
			}
		},

		_handleApiResponse: function (response, w, e) {
			this.data = {};

			if (fox.inArray(['failure', 'error'], e)) {
				console.error("error", response)

				return;
			};

			this.showPopup();
		},

		_change: function (el) {
			var option = el.options[el.selectedIndex];

			fox.dom.selectFirst('.selected', el.parentNode.parentNode).innerHTML = option.innerHTML

			this.toggleField(el.name, false);

			this.data[el.name] = option.value;
		},

		insertSelectTitle: function (txt) {
			this.dom1('.selected').innerHTML = txt;
		},

		showPopup: function (argument) {
			this.wom1('#successPopup').show();

			this.handleEvent(this.wom1('#successPopup'), 'hide', this._redirect, {once: true});
		},

		_redirect: function (argument) {
			fox.site.gotoPage('account')
		}

	}, 'Widget');

})(fox, jQuery);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/widget/billingSupport/billingContact.js
// module id = 846
// module chunks = 4